import React from 'react';

import axios from 'axios';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';

import { withStyles } from '@material-ui/core/styles';

import Alert from '@material-ui/lab/Alert';

import Shared from '../AuthShared/AuthShared';
import FooterComponent from '../Shared/Component/FooterComponent';

import LineChartComponent from './Component/LineChartComponent';
import BarChartComponent from './Component/BarChartComponent';
import AreaChartComponent from './Component/AreaChartComponent';
import LineChartComponentAlternative from './Component/LineChartComponentAlternative';
import BarChartComponentAlternative from './Component/BarChartComponentAlternative';
import AreaChartComponentAlternative from './Component/AreaChartComponentAlternative';
import TableComponent from './Component/TableComponent';
import ButtonComponent from './Component/ButtonComponent';

import { Config } from '../../Config';
import '../../index.css';

const styles = theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    paper: {
        maxWidth: '60vw',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(3),
    },
})

class Dataview extends React.Component {
    constructor() {
        super()
        this.state = {
            location: [],
            channel: [
                {
                    'key': '1',
                    'value': '1',
                    'text': 'Battery Level'
                },
                {
                    'key': '2',
                    'value': '2',
                    'text': 'Rain'
                },
                {
                    'key': '3',
                    'value': '3',
                    'text': 'Water Level'
                }
            ],

            chart: '',

            data: [],

            input_location: '',
            input_channel: '',
            input_startdate: new Date(),
            input_enddate: new Date(),

            trigger_level: [],

            loading: false,
            visible: false,
            visible_alternative: false,
        }
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData = () => {
        this.setState({ loading: true })
        axios.get(Config() + '/dataview/initialize')
            .then(response => {
                this.setState({
                    location: response.data,
                    loading: false
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({ loading: false })
                let error_msg = "Something went wrong. This might be Neon Server is not responding to requests or the backend has failed to process the request."
                this.errorHandler(error_msg)
            })
    }

    onChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    onChangeHandler_startdate = date => {
        this.setState({ input_startdate: date })
    }

    onChangeHandler_enddate = date => {
        this.setState({ input_enddate: date })
    }

    onChangeHandler_chart = (event) => {
        this.setState({ chart: event.target.value })
    }

    queryHandler = () => {
        this.setState({ data: [] })
        if (!this.state.input_location || !this.state.input_channel ||
            !this.state.input_startdate ||
            !this.state.input_enddate || !this.state.chart) {
            let error_msg = "Please fill in/select all the fields."
            this.errorHandler(error_msg)
        }
        else {
            //Check start date and end date
            if (this.state.input_startdate > this.state.input_enddate) {
                let error_msg = "Start Date cannot be later than End Date."
                this.errorHandler(error_msg)
            }
            else {
                this.setState({ loading: true })
                axios.post(Config() + '/dataview/query', {
                    'location': this.state.input_location,
                    'channel': this.state.input_channel,
                    'start_date': this.state.input_startdate,
                    'end_date': this.state.input_enddate
                })
                    .then(response => {
                        if (response.data[0] === "OK") {
                            this.setState({
                                data: response.data[1],
                                trigger_level: response.data[2],
                                alert: false,
                                alertText: '',
                                visible: response.data[3] === "Y" ? false : true,
                                visible_alternative: response.data[3] === "N" ? false : true
                            })
                        }
                        else {
                            let error_msg = "The selected station/channel has no data."
                            this.errorHandler(error_msg)
                        }
                        this.setState({ loading: false })
                    })
                    .catch(error => {
                        console.log(error)
                        this.setState({ loading: false })
                        let error_msg = "Something went wrong. This might be Neon Server is not responding to requests or the backend has failed to process the request."
                        this.errorHandler(error_msg)
                    })
            }
        }
    }

    clearInputHandler = () => {
        this.setState({
            alert: false,
            alertText: '',
            input_location: '',
            input_startdate: null,
            input_enddate: null,
            chart: '',
            visible: false,
            data: [],
            trigger_level: [],
        })
    }

    errorHandler = (error_msg) => {
        this.setState({
            data: [],
            alert: true,
            alertText: error_msg,
            visible: false
        })

        window.scrollTo({
            top: 100,
            left: 0,
            behavior: 'smooth'
        })
    }

    render() {
        const { classes } = this.props
        return (
            <div className="background">
                <Shared action={this.goLogin} />

                <Backdrop className={classes.backdrop}
                    open={this.state.loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Paper className={classes.paper}>
                    {this.state.alert ?
                        <Alert severity="error">
                            {this.state.alertText}
                        </Alert>
                        :
                        null
                    }

                    <br />

                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12}>
                            Select a location:
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                select
                                label="Location"
                                name="input_location"
                                value={this.state.input_location}
                                onChange={this.onChangeHandler}
                            >
                                {this.state.location.map(x => (
                                    <MenuItem key={x.key}
                                        value={x.value}
                                        style={{ whiteSpace: 'normal' }}>
                                        {x.text}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                select
                                label="Channel Type"
                                name="input_channel"
                                value={this.state.input_channel}
                                onChange={this.onChangeHandler}
                            >
                                {this.state.channel.map(x => (
                                    <MenuItem key={x.key}
                                        value={x.value}
                                        style={{ whiteSpace: 'normal' }}>
                                        {x.text}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    inputVariant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Start Date"
                                    name="input_startdate"
                                    format="dd/MM/yyyy"
                                    value={this.state.input_startdate}
                                    onChange={this.onChangeHandler_startdate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    inputVariant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="End Date"
                                    name="input_enddate"
                                    format="dd/MM/yyyy"
                                    value={this.state.input_enddate}
                                    onChange={this.onChangeHandler_enddate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select a type of chart.</FormLabel>
                                <RadioGroup aria-label="position" name="position"
                                    value={this.state.chart}
                                    onChange={this.onChangeHandler_chart} row>

                                    <FormControlLabel
                                        value="line"
                                        control={<Radio color="primary" />}
                                        label="Line Chart"
                                        labelPlacement="end"
                                    />

                                    <FormControlLabel
                                        value="bar"
                                        control={<Radio color="primary" />}
                                        label="Bar Chart"
                                        labelPlacement="end"
                                    />

                                    <FormControlLabel
                                        value="area"
                                        control={<Radio color="primary" />}
                                        label="Area Chart"
                                        labelPlacement="end"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <ButtonComponent
                        loading={this.state.loading}
                        action={this.queryHandler}
                        action_2={this.clearInputHandler} />

                    <br />

                    <Typography variant="caption">
                        *For optimal experience, please use a device that supports larger display resolutions or switch to "Desktop View" in mobile.
                    </Typography>
                </Paper>

                <br />
                <br />

                {this.state.visible ?
                    <React.Fragment>

                        {
                            this.state.chart === "line" ?

                                <LineChartComponent
                                    data={this.state.data} />

                                :

                                this.state.chart === "bar" ?
                                    <BarChartComponent
                                        data={this.state.data} />
                                    :

                                    this.state.chart === "area" ?
                                        <AreaChartComponent
                                            data={this.state.data} />
                                        :

                                        null
                        }

                        {this.state.chart ?
                            <TableComponent
                                data={this.state.data} />
                            :
                            null
                        }
                    </React.Fragment>

                    :

                    null
                }

                {this.state.visible_alternative ?
                    <React.Fragment>

                        {
                            this.state.chart === "line" ?

                                <LineChartComponentAlternative
                                    data={this.state.data}
                                    trigger_level={this.state.trigger_level} />

                                :

                                this.state.chart === "bar" ?
                                    <BarChartComponentAlternative
                                        data={this.state.data}
                                        trigger_level={this.state.trigger_level} />
                                    :

                                    this.state.chart === "area" ?
                                        <AreaChartComponentAlternative
                                            data={this.state.data}
                                            trigger_level={this.state.trigger_level} />
                                        :

                                        null
                        }

                        {this.state.chart ?
                            <TableComponent
                                data={this.state.data} />
                            :
                            null
                        }
                    </React.Fragment>

                    :

                    null
                }

                <FooterComponent />
            </div>
        )
    }
}

export default withStyles(styles, { withTheme: true })(Dataview);